/**
* Select color change
*/

const orderSelect = () => {
  const selectFields = document.querySelectorAll('select');

  if (!selectFields) return;
  selectFields.forEach(select => {
    select.addEventListener("change", (e) => {
      select.classList.add("form__select--black")
    })
  })
}

export default orderSelect
